require('../core');

angular.module('ui-ng-notification').factory('phxNotificationDelegateConfiguration', function (
  phxNotificationMessageBuilder,
  phxNotificationMessageStatusEnum) {

  return {
    uniqueComponent: 'phx-notification',
    vocabulary: {
      create: function (scope, element, attrs, event, content, status) {

        var i;
        var _msg;
        var message = (_.isString(content))
          ? { content: content }
          : content;

        if (_.isUndefined(message)) {
          return;
        }

        message.status = phxNotificationMessageStatusEnum.get(message.status || status || phxNotificationMessageStatusEnum.INFO);

        if (scope.combineDuplications) {
          for (i = scope.messageStack.length - 1; i >= 0; i--) {
            _msg = scope.messages[i];
            if (_msg.content === message.content && _msg.status.key === message.status.key) {
              scope.messages[i].count += 1;
              scope.$applyAsync();
              return scope.messages[i].id;
            }
          }
        }

        if (message.status.value.messageSettings) {
          message = _.merge({}, message.status.value.messageSettings, message);
        }

        message = new phxNotificationMessageBuilder(message);

        if (scope.verticalPosition === 'bottom') {
          scope.messages.unshift(message);
        }
        else {
          scope.messages.push(message);
        }

        scope.messageStack.push(message.id);
        scope.$applyAsync();
        return message.id;
      },
      success: function (scope, element, attrs, event, messageContent) {
        return this.create(messageContent, phxNotificationMessageStatusEnum.SUCCESS);
      },
      info: function (scope, element, attrs, event, messageContent) {
        return this.create(messageContent, phxNotificationMessageStatusEnum.INFO);
      },
      warn: function (scope, element, attrs, event, messageContent) {
        return this.create(messageContent, phxNotificationMessageStatusEnum.WARN);
      },
      error: function (scope, element, attrs, event, messageContent) {
        return this.create(messageContent, phxNotificationMessageStatusEnum.ERROR);
      },
      dismissAlertByName: function (scope, element, attrs, event, name) {
        scope.dismissByName(name);
      },
      dismissAllNotifications: function (scope, element, attrs, event) {
        scope.dismiss();
      }
    }
  };
}).controller('phxNotificationController', function phxNotificationController($scope) {

  $scope.messages = [];
  $scope.messageStack = [];

  $scope.dismiss = function (id) {

    if (id) {
      for (var i = $scope.messages.length - 1; i >= 0; i--) {
        if ($scope.messages[i].id === id) {
          $scope.messages.splice(i, 1);
          $scope.messageStack.splice($scope.messageStack.indexOf(id), 1);
          return;
        }
      }
    }
    else {
      // Emptying both messages and messageStack to dismiss all notifications
      $scope.messages = [];
      $scope.messageStack = [];
    }
  };
  $scope.dismissByName = function (name) {
    var notification = _.find($scope.messages, { "name": name });
    if (notification) {
      $scope.dismiss(notification.id);
    }
  }

}).directive('phxNotification', function (
  DelegateResponder,
  phxNotificationDelegateConfiguration,
  $templateCache) {
  return {
    replace: false,
    restrict: 'E',
    templateUrl: function (element, attrs) {
      return 'ui-ng-notification/dist/templates/' + (attrs.type || 'standard') + '.html';
    },
    scope: {},
    controller: 'phxNotificationController',
    compile: function (element, attrs) {

      var template;

      if (attrs.template) {

        template = $templateCache.get(attrs.template);
        if (!template) {
          throw new Error(`template url for notification is invalid ${attrs.template}`);
        }

        element.replaceWith(template);
      }

      element.attr('role', 'log');
      element.attr('aria-relevant', 'additions removals');
      element.attr('aria-atomic', 'false');
      element.attr('aria-live', 'polite');

      return DelegateResponder(phxNotificationDelegateConfiguration, function notificationLinker(
        scope,
        element,
        attrs) {

        scope.respectEabHeader = (_.isString(attrs.respectEabHeader))
          ? (attrs.respectEabHeader === 'true')
          : false;

        scope.combineDuplications = (_.isString(attrs.combineDuplications))
          ? (attrs.combineDuplications === 'true')
          : true;

        scope.horizontalPosition = (_.isString(attrs.horizontalPosition))
          ? attrs.horizontalPosition
          : 'right';

        scope.verticalPosition = (_.isString(attrs.verticalPosition))
          ? attrs.verticalPosition
          : 'top';

        scope.animation = (_.isString(attrs.animation))
          ? attrs.animation
          : 'slide';

      });
    }
  };
}).service('phxNotificationDelegate', function phxSelectDelegate(
  DelegateController,
  phxNotificationDelegateConfiguration) {
  DelegateController(this, phxNotificationDelegateConfiguration);
});



// WEBPACK FOOTER //
// notification_container.es.js